import React from 'react'
import SuccessStory from './successStory'

export default function Banners() {
    return (
        <div>
            <SuccessStory />
        </div>
    )
}
